const IBAN_CZ_COUNTRY_CODE = "CZ";
const IBAN_CZ_MOD97_COUNTRY_DIGITS = "1235"; // C=12, Z=35
const IBAN_CZ_PREFIX_LENGTH = 6;
const IBAN_CZ_ACCOUNT_NUMBER_LENGTH = 10;
const IBAN_CZ_BANK_CODE_LENGTH = 4;
const IBAN_MOD97_DIVISOR = 97;
const IBAN_MOD97_CHECK_DIGITS_BASE = 98;
const CZECH_ACCOUNT_NUMBER_PATTERN = /^(?:(\d{1,6})-)?(\d{1,10})\/(\d{4})$/;
const CZECH_IBAN_PATTERN = /^CZ\d{22}$/;

function calculateIbanCheckDigits(bban: string): string {
    const rearranged = bban + IBAN_CZ_MOD97_COUNTRY_DIGITS + "00";
    let remainder = 0;
    for (const digit of rearranged) {
        remainder = (remainder * 10 + parseInt(digit)) % IBAN_MOD97_DIVISOR;
    }
    return String(IBAN_MOD97_CHECK_DIGITS_BASE - remainder).padStart(2, "0");
}

export function convertCzechAccountToIban(accountNumber: string): string {
    const accountNumberWithoutSpaces = accountNumber.replace(/\s/g, "");
    if (CZECH_IBAN_PATTERN.test(accountNumberWithoutSpaces)) {
        return accountNumberWithoutSpaces;
    }
    const match = accountNumberWithoutSpaces.match(CZECH_ACCOUNT_NUMBER_PATTERN);
    if (!match) {
        throw new Error(`Invalid account number format: "${accountNumber}"`);
    }
    const prefix = (match[1] ?? "0").padStart(IBAN_CZ_PREFIX_LENGTH, "0");
    const number = match[2].padStart(IBAN_CZ_ACCOUNT_NUMBER_LENGTH, "0");
    const bankCode = match[3].padStart(IBAN_CZ_BANK_CODE_LENGTH, "0");
    const bban = bankCode + prefix + number;
    const checkDigits = calculateIbanCheckDigits(bban);
    return `${IBAN_CZ_COUNTRY_CODE}${checkDigits}${bban}`;
}
